/**
 * Component default class name and class prefix.
 */
export const TABS_CLASSNAME = `lumx-tabs`;
